import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AmazoniaReal: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    background: '#0a0a0a',
    color: '#222',
    fontFamily: "'Inter', Arial, Helvetica, sans-serif",
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Header />
    <main style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }}>
      <div style={{
        maxWidth: 900,
        width: '100%',
        margin: '40px auto',
        background: '#fff',
        padding: 32,
        borderRadius: 8,
        boxSizing: 'border-box',
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src="/images/logo/amazoniareal.jpg"
            alt="Déchets toxiques à Belém"
            style={{
              width: '100%',
              maxWidth: 300,
              borderRadius: 8,
              margin: '20px 0'
            }}
          />
        </div>
        <h1 style={{ color: '#0a3d62', marginTop: 0 }}>Doença, lixo e silêncio: relatório oficial revela contaminação em Belém às vésperas da COP 30</h1>
        <div style={{ color: '#888', fontSize: '0.95em', marginBottom: 24 }}>
          Por Mariana Costa | Belém (PA) Publicado em 9 de outubro de 2025

        </div>
        <h2 style={{ color: '#222', fontWeight: 600, marginBottom: 12 }}>
          Um relatório técnico da Secretaria Municipal de Saúde de Belém, obtido com exclusividade pelo portal Amazônia Real
        </h2>
        <img
          src="/images/accor/criancalixao.jpg"
          alt="Aterro do Aurá"
          style={{
            width: '100%',
            maxWidth: 700,
            borderRadius: 8,
            margin: '20px 0'
          }}
        />
        <p>
          Um relatório técnico da Secretaria Municipal de Saúde de Belém, obtido com exclusividade pelo Portal Amazônia Real, revela um cenário alarmante: <b>52 moradores do bairro Marambaia estão doentes com  Febre Tifóide</b>, possivelmente causadas pela contaminação do córrego local — resultado direto do <b>descarte irregular de lixo pela empresa Lev Descartes</b>.
          A investigação aponta presença de <b>coliformes fecais, metais pesados e resíduos orgânicos</b> em níveis acima do permitido. A água usada por famílias da região está imprópria para consumo, e o solo apresenta risco de contaminação crônica.
        </p>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18, marginTop: 32 }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ color: '#0a3d62', margin: 0 }}>
              O lixo que não aparece nas diárias
            </h3>
            <p style={{ marginTop: 10 }}>
              A Lev Descartes é contratada por diversas unidades da <b>rede hoteleira de Belém</b>, que, segundo denúncias, <b>não realiza o recolhimento adequado de seus resíduos</b>. Enquanto isso, hotéis como os da <b>rede Accor, Radisson Hotel Group, Bristol e outros conglomerados internacionais</b> seguem cobrando <b>diárias que ultrapassam R$ 12.000,00</b>, mesmo em bairros próximos à área contaminada.
            </p>
            <blockquote style={{
              borderLeft: '4px solid #0a3d62',
              margin: '16px 0 0 0',
              paddingLeft: 16,
              color: '#444',
              fontStyle: 'italic'
            }}>
              "É um absurdo. Eles lucram com turismo e despejam lixo no nosso córrego. A gente adoece, eles vendem sustentabilidade."<br />
              <span style={{ fontWeight: 500 }}>— Relata um morador que preferiu não se identificar.</span>
            </blockquote>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18, marginTop: 32 }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ color: '#0a3d62', margin: 0 }}>
              Omissão e silêncio
            </h3>
            <p style={{ marginTop: 10 }}>
              Até o momento, <b>nenhuma das redes hoteleiras citadas se pronunciou oficialmente</b>. A prefeitura, por sua vez, é acusada de <b>pressionar pela reativação do aterro do Aurá</b>, desativado em 2021 por não cumprir normas ambientais.
            </p>
            <p style={{ marginTop: 10 }}>
              O relatório da Secretaria de Saúde recomenda ações emergenciais de <b>contenção, suspensão do descarte e responsabilização das empresas envolvidas</b>.
            </p>
          </div>
        </div>
        <div style={{
          background: '#eaf6fb',
          borderRadius: 6,
          padding: 18,
          margin: '32px 0',
          color: '#0a3d62',
          fontWeight: 500,
          fontSize: '1.1em'
        }}>
          <b>Leia o relatório na íntegra abaixo</b><br />
          <span style={{ color: '#222', fontWeight: 400 }}>
            O Portal Amazônia Real disponibiliza o documento completo para consulta pública. <br />
            A verdade precisa ser conhecida — e cobrada.<br />
            <a href='/files/Relatoriodasecretaria.pdf' target='_blank'>📎</a> [Relatório Técnico nº 014/2025 – SMSB/DSA]<br />

            📩 Denúncias e relatos podem ser enviados para:

            <a href="mailto:redacao@amazoniareal.com.br" style={{ color: '#0077cc' }}>
              redacao@amazoniareal.com.br
            </a>
          </span>
        </div>
        <div style={{
          color: '#888',
          fontSize: '0.95em',
          marginTop: 16,
          wordBreak: 'break-word'
        }}>
          #JustiçaAmbiental #COP30 #Greenwashing #Pará #RedeHoteleira #LevDescartes #Aurá #SustentabilidadeDeFachada #DireitosHumanos #AmazôniaReal
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default AmazoniaReal; 